import React, { useState } from "react"
import { useLocation } from 'react-router-dom';
import { useSidebar } from "@/components/shadcn/sidebar"

import { ChevronRight} from "lucide-react"

import {
    Collapsible,
    CollapsibleContent,
    CollapsibleTrigger,
} from "@/components/shadcn/collapsible"
import {
    SidebarGroup,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarMenuSub,
    SidebarMenuSubButton,
    SidebarMenuSubItem,
} from "@/components/shadcn/sidebar"
import { NavLink } from "react-router-dom";

export default function NavMain({
    items,
}: {
  items: {
    title: string
    url: string
    icon: React.ReactNode
    isActive?: boolean
    hidden?: boolean
    items?: {
      title: string
      url: string
      hidden?: boolean
    }[]
  }[]
}) {
    const location = useLocation();
    const { state, setOpen } = useSidebar();
    const [justOpenedSidebar, setJustOpenedSidebar] = React.useState(false);

    // Trouver le parent actif en vérifiant si l'un de ses sous-items correspond à l'URL actuelle
    const activeParent = items.find(item =>
        item.items?.some(subItem => subItem.url === location.pathname)
    );

    const [openItem, setOpenItem] = useState<string | null>(
        activeParent?.title || items.find(item => item.isActive)?.title || null
    )

    React.useEffect(() => {
        if (activeParent) {
            setOpenItem(activeParent.title);
        }
    }, [location.pathname, activeParent]);

    React.useEffect(() => {
        if (justOpenedSidebar) {
            const timeout = setTimeout(() => setJustOpenedSidebar(false), 100);
            return () => clearTimeout(timeout);
        }
    }, [justOpenedSidebar]);

    const handleToggle = (title: string) => {
        setOpenItem(prev => (prev === title ? null : title))
    }

    return (
        <SidebarGroup>
            <SidebarGroupLabel className="text-base font-semibold">Menu</SidebarGroupLabel>
            <SidebarMenu>
                {items
                    ?.filter(item => !item.hidden)
                    .map((item) => (
                        <Collapsible
                            key={item.title}
                            asChild
                            open={openItem === item.title}
                            onOpenChange={() => {
                                if (justOpenedSidebar) return;
                                handleToggle(item.title);
                            }}
                            className="group/collapsible"
                        >
                            <SidebarMenuItem>
                                <CollapsibleTrigger asChild>
                                    <SidebarMenuButton
                                        className="h-auto"
                                        tooltip={item.title}
                                        onClick={(e) => {
                                            if (state !== "collapsed") {
                                                return;
                                            }
                                            e.preventDefault();
                                            // Si le menu n'est pas déjà ouvert, on l'ouvre
                                            if (openItem !== item.title) {
                                                setOpenItem(item.title);
                                            }
                                            setOpen(true);
                                            setJustOpenedSidebar(true);
                                        }}
                                    >
                                        <div className="w-auto">{item.icon}</div>
                                        <span className="text-lg">{item.title}</span>
                                        <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                                    </SidebarMenuButton>
                                </CollapsibleTrigger>
                                <CollapsibleContent>
                                    <SidebarMenuSub>
                                        {item.items
                                            ?.filter(subItem => !subItem.hidden)
                                            .map((subItem) => (
                                                <SidebarMenuSubItem key={subItem.title}>
                                                    <SidebarMenuSubButton>
                                                        <NavLink to={subItem.url} className={({ isActive }) => (isActive ? "text-gradient" : "")}>
                                                            {subItem.title}
                                                        </NavLink>
                                                    </SidebarMenuSubButton>
                                                </SidebarMenuSubItem>
                                            ))}
                                    </SidebarMenuSub>
                                </CollapsibleContent>
                            </SidebarMenuItem>
                        </Collapsible>
                    ))}
            </SidebarMenu>
        </SidebarGroup>
    )
}
